import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Catalog, CatalogWithAncestors, DamElasticDTO, ListTable, NgxEasyTablePagination} from 'compob2b-libs';
import {BehaviorSubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {translations} from '../../../../../../../environments/translations.ru';
import {
  DamChooseCatalogModalComponent
} from '../../../../../../admin-shared/custom-form-types/dam-choose-catalog-modal/dam-choose-catalog-modal.component';

interface ContextType {
  catalogChosenEvent: EventEmitter<CatalogWithAncestors>;
  removeCatalogEvent: EventEmitter<CatalogWithAncestors>;
  chosenCatalogs?: Catalog[];
  onlyOneSelection?: boolean;
  chooseOnlyLastLevel?: boolean;
}

@Component({
  selector: 'app-plates-view',
  templateUrl: './plates-view.component.html',
  styleUrls: ['./plates-view.component.scss'],
})

export class PlatesViewComponent extends ListTable implements OnInit {
  @Input() pagination: NgxEasyTablePagination;

  @Input() set damElements(value: DamElasticDTO[]) {
    this._damElements = value;
    this.damElements$.next(value);
    console.log('damElements$.value', this.damElements$.value);
  }

  _damElements: DamElasticDTO[] = [];
  @Input() damElements$ = new BehaviorSubject<DamElasticDTO[]>([]);
  @Output() elementClickEventEmitter = new EventEmitter<DamElasticDTO>();
  @Output() elementSelectEvent = new EventEmitter<DamElasticDTO>();
  @Output() allElementSelectEvent = new EventEmitter<DamElasticDTO[]>();
  @Output() elementDownloadEvent = new EventEmitter<DamElasticDTO>();
  @Output() elementDeleteEvent = new EventEmitter<DamElasticDTO>();
  @Output() elementShareEvent = new EventEmitter<DamElasticDTO>();
  @Output() elementChangeCatalogEvent = new EventEmitter<DamElasticDTO>();
  @Input() isShowProductList: boolean;
  @Input() selected$ = new BehaviorSubject(new Set());

  catalogChosenEvent = new EventEmitter<CatalogWithAncestors>();
  removeCatalogEvent = new EventEmitter<CatalogWithAncestors>();

  damItemChangeCatalogId = 0;
  isAllItemsSelected = false;

  markSelectedElements() {
    this._damElements.forEach(item => {
      item.selected = this.selected$.value.has(item.id);
    });
    console.log('palte view restart');
    this.isAllItemsSelected = !this.hasUnselected(this._damElements);
    console.log('_damElements', this._damElements);
  }

  ngOnInit() {
    this.markSelectedElements();

    this.catalogChosenEvent
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        this.compoApiService.post('/dam/items/change-catalog/', {
          damCatalogId: response?.id,
          damItemId: this.damItemChangeCatalogId
        }).pipe(takeUntil(this.unsubscribe)).subscribe();
      }
    );
  }

  elementClickEvent(damElement: DamElasticDTO) {
    this.elementClickEventEmitter.emit(damElement);
  }

  elementSelectHandler(damElement: DamElasticDTO, $event) {
    damElement.selected = $event;
    if ($event) {
      this.selected$.value.add(damElement.id);
    } else {
      this.selected$.value.delete(damElement.id);
    }
    console.log('selected$', this.selected$.value);
    this.isAllItemsSelected = !this.hasUnselected(this._damElements);
    this.elementSelectEvent.emit(damElement);
  }

  elementDownloadHandler(damElement: DamElasticDTO) {
    this.elementDownloadEvent.emit(damElement);
  }

  elementDeleteHandler(damElement: DamElasticDTO) {
    this.elementDeleteEvent.emit(damElement);
  }

  elementShareHandler(damElement: DamElasticDTO) {
    this.elementShareEvent.emit(damElement);
  }

  elementChangeCatalogHandler(damElement: DamElasticDTO) {
    this.damItemChangeCatalogId = damElement?.id;
    const data: ContextType = {
      catalogChosenEvent: this.catalogChosenEvent,
      removeCatalogEvent: this.removeCatalogEvent,
      chosenCatalogs: null,
    };
    data.onlyOneSelection = true;
    data.chooseOnlyLastLevel = true;

    this.windowService.open(DamChooseCatalogModalComponent, {
      context: data,
      title: translations.catalog
    });
  }

  // FOR TABLE VIEW
  toggleCheckboxes() {
    if (this.hasUnselected(this._damElements)) {
      this._damElements.forEach(damItem => {
        damItem.selected = true;
        this.selected$.value.add(damItem.id);
      });
      this.isAllItemsSelected = true;
      this.allElementSelectEvent.emit(this._damElements);
    } else {
      this._damElements.forEach(damItem => {
        damItem.selected = false;
        this.selected$.value.delete(damItem.id);
      });
      this.isAllItemsSelected = false;
      this.allElementSelectEvent.emit([]);
    }
    console.log('selectedElementsIds', this.selected$.value);
  }

  hasUnselected(items) {
    return items.some(item => !item?.selected);
  }

  deleteItem(damElement: DamElasticDTO) {
    // this.customToast.show('Success!', 'Operation completed successfully.', 'success', 1000000);
  }

}
